
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { FormControl, FormItem, FormLabel } from '@/components/ui/form';
import { ControllerRenderProps } from 'react-hook-form';

interface RememberMeCheckboxProps {
  field: ControllerRenderProps<any, 'rememberMe'>;
}

const RememberMeCheckbox: React.FC<RememberMeCheckboxProps> = ({ field }) => {
  return (
    <FormItem className="flex flex-row items-start space-x-3 space-y-0 py-1">
      <FormControl>
        <Checkbox
          checked={field.value}
          onCheckedChange={field.onChange}
          id="rememberMe"
          className="data-[state=checked]:bg-primary-blue data-[state=checked]:border-primary-blue"
        />
      </FormControl>
      <FormLabel htmlFor="rememberMe" className="text-sm font-medium leading-none cursor-pointer">
        Remember me for 30 days
      </FormLabel>
    </FormItem>
  );
};

export default RememberMeCheckbox;
